import React from 'react';
import { observer, inject } from "mobx-react";
import { Input, InputValidation , Spinner, Notification } from '@sogei/react-web-components-catalog'
import { ROUTE_PROFILAZIONE , ROUTE_FERMO } from "../../assets/frontendRouting";
import { UploadFlow } from '@sogei/flow-uploader';
import { breadcrumbTrasmissionePegno } from '../../assets/breadcrumb';
import i18next from 'i18next';
//import { Card } from '../commons/cardApp';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { scrollToTop } from '../commons/uiUtils';
import { values } from 'mobx';
import { A2D_STATUS_DA_ESEGUIRE , A2D_STATUS_IN_ELABORAZIONE  , A2D_STATUS_ELABORATO  , A2D_STATUS_IN_ERRORE , A2D_STATUS_SCARTATO , A2D_STATUS_IN_ATTESA , A2D_ERROR_CODE_ANTIVIRUS} from "../../config/presdoc-fe-services-util";
import IstruzioniInvio from '../trasmissione/istruzioniInvio';
//import SceltaTipoInvio from '../trasmissione/tipoInvio';
import {SceltaTipoInvio, defaultTipoInvio , getTipoInvio} from '../trasmissione/tipoInvio';
import {regexLettereMaiuscoleMinuscoleNumeriSpazioUnderscoreTrattino} from '../../assets/utils/regexp'




@inject("rootStore")
@observer
class Trasmissione extends React.Component {

    constructor(props) {
        super(props);
        this.formikRef = React.createRef();
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onUploadFunctionHandler = this.onUploadFunctionHandler.bind(this);
        this.onVerifyFunctionHandler = this.onVerifyFunctionHandler.bind(this);
        this.trasmissioneStore = props.rootStore.trasmissioneStore;
        this.qualificheStore = props.rootStore.qualificheStore;
        this.routingStore = props.rootStore.routingStore;
        this.fermoStore = props.rootStore.fermoStore;
        this.tipoPratica = this.qualificheStore.tipoPratica;
        this.state = {
          domandaFile : undefined,
          titoloFile : undefined,
          procuraFile : undefined,
          listaDescrizioneErrore: undefined,
          validazioneOKUpload: false,
          validazioneOKVerify: false,
          isA2DErroreProcesso: false,
          isA2DNonSuperato: false,
          inserimentoDocumenti: true
        }
        this.validationSchema = Yup.object({
          
          identificativoMnemonicoPratica: Yup.mixed()
          .required(i18next.t("VALIDATION_IDENTIFICATIVO_MNEMONICO_PRATICA")).test(i18next.t("VALIDATION_IDENTIFICATIVO_MNEMONICO_PRATICA_INVALID"),i18next.t("VALIDATION_IDENTIFICATIVO_MNEMONICO_PRATICA_INVALID"),(value)=> {
            if(!value) {
              return false;
            }
            return regexLettereMaiuscoleMinuscoleNumeriSpazioUnderscoreTrattino(value);
          })


        });
    }  
    

    componentDidMount() {
      this.trasmissioneStore.reset();

      
    this.fermoStore.controllaFermo(this.tipoPratica).then( () => {
    if(this.fermoStore.servizioAttivo === false){
      this.routingStore.push('/PresdocWEB'+`${ROUTE_FERMO}`);
    }
  }
    )



    }

    componentWillUnmount() { }



    onUploadFunctionHandler(flowIdentifiers){
      console.log('flowIdentifiers (0)',flowIdentifiers[0])
      if(flowIdentifiers[0]){
        console.log('flowIdenifiers (0).file',flowIdentifiers[0].flowFile.file)
        this.state.domandaFile = flowIdentifiers[0].flowFile.file;
        this.trasmissioneStore.recuperaIdAtmos(flowIdentifiers[0].flowFile.file.flowIdentifier, 'domanda');
        
       }
     if(flowIdentifiers.length >1){
      console.log('flowIdentifiers (1)',flowIdentifiers[1].flowFile)
       this.state.titoloFile = flowIdentifiers[1].flowFile;
      this.trasmissioneStore.recuperaIdAtmos(flowIdentifiers[1].flowFile.file.flowIdentifier,'titolo') ;
      //this.state.titoloFile =  this.trasmissioneStore.idAtmos;
     }
     if(flowIdentifiers.length >2){
      console.log('flowIdentifiers (2)',flowIdentifiers[2])
      this.state.procuraFile = flowIdentifiers[2].flowFile.file;
      this.trasmissioneStore.recuperaIdAtmos(flowIdentifiers[2].flowFile.file.flowIdentifier,'procura') ;
     
     }
     this.state.validazioneOKUpload = true
     
    }

    onVerifyFunctionHandler(){

      let params = {};
      let allegatoTitolo = {};
      let allegatoProcura = {};
      this.state.inserimentoDocumenti = false;
      params.allegati = [];
      params.nomeFile = this.state.domandaFile.name; 
      params.tipoPratica = this.tipoPratica
      this.setState({isA2DErroreProcesso : false});
      this.setState({isA2DNonSuperato: false})
      
      params.idAtmos =  this.trasmissioneStore.idAtmosDomanda;

      ({ allegatoTitolo, allegatoProcura } = this.preparaAllegati(allegatoTitolo, params, allegatoProcura));

      console.log("params",  params);
      if(this.qualificheStore.esitoContestuale === true){
        params.tipoInvio= 'B';  
      }
      else{
        params.tipoInvio= 'N';
      }
      
      let p = this.trasmissioneStore.verificaFile(params);
      
      this.state.validazioneOKUpload = false;
      let tentativi= 90;

      /*if(process.env.SKIP_A2D){
        this.setState({validazioneOKVerify : true})
      }*/
      p.then(()=>{
            var interval =  setInterval(() => {
            this.trasmissioneStore.loading= true;
            let ctrlA2D = this.trasmissioneStore.controlloServizioA2D(this.trasmissioneStore.codiceInvio);
            ctrlA2D.then(() => {

            if (this.trasmissioneStore.esitoA2D!== undefined && this.trasmissioneStore.esitoA2D.every(x => x.stato!= A2D_STATUS_IN_ATTESA)) {
      
              console.log("esitoA2D", this.trasmissioneStore.esitoA2D)
              
              
              this.setState({isA2DErroreProcesso : this.trasmissioneStore.esitoA2D.some(doc => doc.stato==A2D_STATUS_IN_ERRORE) })
              console.log("isA2DErroreProcesso"+ this.state.isA2DErroreProcesso)
              let listaDocumentiConErrore = [];
              let listaDocumentiErrore = this.trasmissioneStore.esitoA2D.filter( esitoX => esitoX.listaErrori != undefined)
              if(!this.state.isA2DErroreProcesso) {
                if(listaDocumentiErrore.length!=0){
                  console.log("Lde:  "+listaDocumentiErrore)
                  listaDocumentiConErrore = listaDocumentiErrore.filter( esito => esito.listaErrori.filter(errore => errore.codErrore=== A2D_ERROR_CODE_ANTIVIRUS ) ) //aggiungere OR per firma e formato
                  if(listaDocumentiConErrore.length!=0){
                    //console.log("listaDocumentiConErrore: " , JSON.stringify(listaDocumentiConErrore))    
                    let appoggio  = new Array();
                    listaDocumentiConErrore.forEach ( virus => appoggio = appoggio.concat(virus.listaErrori.map(errore => errore.dettErroreSintetico)) )            
                    this.setState({listaDescrizioneErrore :  appoggio})
                    this.setState({isA2DNonSuperato: true})
                    console.log("listaDescrizioneErrore: " , this.state.listaDescrizioneErrore)
                    this.setState({validazioneOKUpload:true});
                  }
                }
                else{
                  this.setState({validazioneOKVerify : true})
                }
                scrollToTop();
              }
              else{
                this.setState({validazioneOKUpload:true});
              } 
              this.trasmissioneStore.loading= false;
              clearInterval(interval);
              }  
              tentativi= tentativi-1;
              console.log(tentativi)
              if(tentativi === 0){
                this.setState({validazioneOKUpload:true});
                this.setState({isA2DErroreProcesso : true})
                this.trasmissioneStore.loading= false;
                clearInterval(interval);
                scrollToTop();          
            }   
        })
        ctrlA2D.catch(()=>{
          tentativi= tentativi-1;
          console.log(tentativi)
          if(tentativi === 0){
            this.setState({validazioneOKUpload:true});
            this.setState({isA2DErroreProcesso : true})
            this.trasmissioneStore.loading= false;
            clearInterval(interval);
            scrollToTop();          
        }   
        })
        
      }, 5000)   
      })
    .catch(() =>{
      console.log("Sono nel catch");
      this.setState({
        validazioneOKUpload:true,
        inserimentoDocumenti:true                        
      })
      
    })

      
    
  }

 



  preparaAllegati(allegatoTitolo, params, allegatoProcura) {
    if (this.state.titoloFile) {
      let tipoFileTitolo = 'TITP';

      if (tipoFileTitolo.toLowerCase().includes('tif')) {
        tipoFileTitolo = 'TITF';
      }

      allegatoTitolo = {
        tipoFile: tipoFileTitolo,
        nomeFile: this.state.titoloFile.name,
        // nomeFile : 'titolo.pdf.p7m', //this.state.titoloFile.name
        dimensioneFile: this.state.titoloFile.size,
        idAtmos: this.trasmissioneStore.idAtmosTitolo
      };
      params.allegati.push(allegatoTitolo);
    }

    if (this.state.procuraFile) {

      let tipoFileProcura = 'MPPP';

      if (tipoFileProcura.toLowerCase().includes('tif')) {
        tipoFileProcura = 'MPPF';
      }

      allegatoProcura = {
        tipoFile: tipoFileProcura,
        nomeFile: this.state.procuraFile.name,
        // nomeFile : 'procura.pdf.p7m', //this.state.procuraFile.name
        dimensioneFile: this.state.procuraFile.size,
        idAtmos: this.trasmissioneStore.idAtmosProcura
      };
      params.allegati.push(allegatoProcura);
    }
    return { allegatoTitolo, allegatoProcura };
  }

  onReset(values,actions){
  //onReset(props) {
   /*   console.log("onReset");
      this.trasmissioneStore.reset();
      props.setFieldValue('identificativoMnemonicoPratica','',false); */
      //console.log("values ", JSON.stringify(values));
      window.location.reload();    
    }

    onSubmit(values,actions) {
    
      console.log("idPratica in invio", this.trasmissioneStore.codiceInvio);
      console.log("this.state.domandaFile",  this.state.domandaFile);
      console.log("this.state.titoloFile",  this.state.titoloFile);
      console.log("this.state.procuraFile",  this.state.procuraFile);

      
      let params = {};
      let allegatoTitolo = {}
      let allegatoProcura = {}
     
//      params.tipoPratica = "MP"
      params.tipoPratica = this.tipoPratica
     // params.tipoInvio = "N"
      params.tipoInvio = values.tipoInvio
      params.identificativoMnemonico = values.identificativoMnemonicoPratica
      params.tipoFile = this.qualificheStore.esitoContestuale?'XML':'P7M'
      //params.nomeFile = 'domanda.xml.p7m' ////this.state.domandaFile.name
      params.nomeFile = this.state.domandaFile.name
      params.dimensioneFile = this.state.domandaFile.size
      params.allegati = []
      params.idAtmos =  this.trasmissioneStore.idAtmosDomanda
      params.idPratica = this.trasmissioneStore.codiceInvio

      if (this.state.titoloFile) {
        let tipoFileTitolo = 'TITP';
  
        if (tipoFileTitolo.toLowerCase().includes('tif')) {
          tipoFileTitolo = 'TITF';
        }
  
        allegatoTitolo = {
          tipoFile: tipoFileTitolo,
          nomeFile: this.state.titoloFile.name,
          // nomeFile : 'titolo.pdf.p7m', //this.state.titoloFile.name
          dimensioneFile: this.state.titoloFile.size,
          idAtmos: this.trasmissioneStore.idAtmosTitolo
        };
        params.allegati.push(allegatoTitolo);
      }
  
      if (this.state.procuraFile) {
  
        let tipoFileProcura = 'MPPP';
  
        if (tipoFileProcura.toLowerCase().includes('tif')) {
          tipoFileProcura = 'MPPF';
        }
  
        allegatoProcura = {
          tipoFile: tipoFileProcura,
          nomeFile: this.state.procuraFile.name,
          // nomeFile : 'procura.pdf.p7m', //this.state.procuraFile.name
          dimensioneFile: this.state.procuraFile.size,
          idAtmos: this.trasmissioneStore.idAtmosProcura
        };
        params.allegati.push(allegatoProcura);
      }

      console.log("params",  params);
      this.trasmissioneStore.invio(params);
      this.setState({validazioneOKVerify: false,
                     inserimentoDocumenti: true      
      })
      if(this.qualificheStore.esitoContestuale){
        this.trasmissioneStore.codiceInvio= params.idPratica;
       
        this.trasmissioneStore.gotoEsitiContestuali();
      }
    }

    render() {      
      const loading = this.trasmissioneStore.loading;
      const maxFiles = this.tipoPratica == 'MP'? '3': '1'
      const extensions= ['xml','p7m']
      const validation = (touched, errors) => {
        if((touched.identificativoMnemonicoPratica && errors.identificativoMnemonicoPratica)
        || (touched.value && errors.value)
            ) {
                return <>
                    <InputValidation show={touched.identificativoMnemonicoPratica && errors.identificativoMnemonicoPratica} error={errors.identificativoMnemonicoPratica} />
                </>
        }
        return null
      }
      
      
        return (
          <div className="container-fluid pr-3 pl-3 pb-3">
             <div className="row">              
              <div className="col">
                {this.qualificheStore.esitoContestuale!== true ? <h1>{i18next.t("TRASMISSIONE_TITLE")}</h1>:<h1>{i18next.t("CONTROLLO_TITLE")}</h1> }

                    {
                         this.state.isA2DErroreProcesso ?
                         <Notification title='Verifica non completata, riprovare più tardi' notificationType={'danger'}/> 
                        : null 
                    }
                    {
                      
                         this.state.isA2DNonSuperato ?
                         <Notification title= {'I seguenti controlli non sono stati superati: '} subtitle={ <><ul>{ this.state.listaDescrizioneErrore.map((errore, index) => <li key={index}>{errore}</li>)}</ul></>}
                         notificationType={'danger'}/> 
                        : null 

                         
                          
                          
                         
                    } 
                    {
                        this.props.rootStore.trasmissioneStore.invioEffettuato && this.props.rootStore.trasmissioneStore.codiceInvio > 0 ?
                        <Notification title='Pratica acquisita dal sistema' subtitle={'Nella sezione ricevute è disponibile lo stato di avanzamento della pratica con codice invio '+this.props.rootStore.trasmissioneStore.codiceInvio} notificationType={'info'}/>                        
                        // <Messages successMessages={[{text:'Iscrizione completata con successo con identificativo: '+descServizioSelezionato}]} infoMessages={[]} warningMessages={[]} dangerMessages={[]}></Messages> 
                        :  this.props.rootStore.trasmissioneStore.invioEffettuato && this.props.rootStore.trasmissioneStore.codiceInvio == 0  ? <Notification title='Invio pratica fallito' subtitle={this.props.rootStore.trasmissioneStore.erroreInvio} notificationType={'danger'}/> 
                        : null 
                    }

                    {
                        this.state.validazioneOKVerify && !this.props.rootStore.trasmissioneStore.invioEffettuato && !this.qualificheStore.esitoContestuale?
                        <Notification title='Controlli preliminari superati con successo' subtitle={'Premendo il tasto "Invia" è possibile inviare la pratica'} notificationType={'success'}/>                        
                        : null 
                    }
                    {
                        this.state.validazioneOKVerify && !this.props.rootStore.trasmissioneStore.invioEffettuato && this.qualificheStore.esitoContestuale?
                        <Notification title='Controlli preliminari superati con successo' subtitle={'Premendo il tasto "Controlla" è possibile procedere coi controlli'} notificationType={'success'}/>                        
                        : null 
                    }

                  <div>
                    <IstruzioniInvio tipoPratica = {this.tipoPratica} esitoContestuale = {this.qualificheStore.esitoContestuale}/>
                     
                   </div>


                
                  
                    <Formik 
                      ref={(ref) => this.formikRef = ref}
                      initialValues={{
                        identificativoMnemonicoPratica: this.qualificheStore.esitoContestuale?'Blackbox-portale':'',
                        tipoInvio : getTipoInvio(this.qualificheStore.esitoContestuale),
                      // tipoInvio : this.tipoPratica == 'UN'?'S': 'N'
                       
                      }}
                      validationSchema={this.validationSchema}
                      enableReinitialize={true}
                      onSubmit={(values, actions) => {
                          scrollToTop();
                          this.onSubmit(values,actions);
                      }}
                      onReset={(values, actions) => {
                        scrollToTop();
                        this.onReset(values,actions);
                    }}
                    >
                      {props => (
                        <>
                          <div className="my-2">
                              {validation(props.touched, props.errors)}
                          </div>
                          <div>
                         
                          {loading && <Spinner isLoading={true}> </Spinner>}
                            <div className='row'>
                            {!this.qualificheStore.esitoContestuale &&
                              <div className='col-sm-12 col-md-6 col-xl-4'>
                                <Input
                                  id="identificativoMnemonicoPratica"
                                  name="identificativoMnemonicoPratica"
                                  value={props.values.identificativoMnemonicoPratica}
                                  type="text"
                                  dimension="lg"
                                  label={i18next.t("IDENTIFICATIVO_MNEMONICO_PRATICA")}
                                  error={props.touched.identificativoMnemonicoPratica && props.errors.identificativoMnemonicoPratica}
                                  labelClass={[]}
                                  inputClass={[]}
                                  event={{ onChange:  props.handleChange }}
                                  extraProps={{
                                      isMandatory: true,
                                    }}
                                />
                              </div>
                              }
                            </div>
                            <div className='row'>
                           { !this.qualificheStore.esitoContestuale &&
                           <div className='col-sm-12 col-md-6 col-xl-4'>
                          <SceltaTipoInvio values={props.values}  onChange={props.handleChange}  tipoPratica = {this.tipoPratica} />
                         
                           </div>
                          }
                         </div>
                            <div className='row'>
                              <div className='col-sm-12 col-md-6 col-xl-6'>
                               <fieldset disabled={!this.state.inserimentoDocumenti}>
                                  <UploadFlow 
                                    extensions={extensions} 
                                    maxFiles={maxFiles} 
                                    maxSize={this.tipoPratica==='MP'?process.env.MAX_FILE_SIZE_MP:process.env.MAX_FILE_SIZE}                                     
                                    onUploadFunction={(flowIdentifiers)=>{
                                          this.onUploadFunctionHandler(flowIdentifiers);
                                    }}                                       
                                  
                                                           
                                  />
                                </fieldset>
                              </div>
                            </div>
                            
                            <div className='row mt-3'>
                              <div className='col'>
                              <AppButton id="verificaFile" type="button" titleKey="BUTTON_VERIFICA" iconLeft="fa fa-shield-virus" customClass="mr-2"
                                  disabled={!this.state.validazioneOKUpload} onClick={() => {this.onVerifyFunctionHandler()}}></AppButton>
                               <AppButton id="invioTrasmissione" type="button" titleKey={!this.qualificheStore.esitoContestuale?"BUTTON_INVIA":"BUTTON_CONTROLLA"} iconLeft="fa fa-paper-plane" customClass="mr-2"
                                  disabled={!this.state.validazioneOKVerify} onClick={() => {this.formikRef.handleSubmit()}}></AppButton>                
                                <AppButton id="ripulisciRicerca" type="reset" titleKey="BUTTON_RIPULISCI" iconLeft="fas fa-eraser" 
                                    onClick={() => {this.formikRef.handleReset()}}></AppButton>                                
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </Formik>
                
              </div>
            </div>
          </div>
        ); 
      }
}


export default Trasmissione

export { Trasmissione }

